
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create/login",
      function () {
        return require("private-next-pages/create/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create/login"])
      });
    }
  